module.exports = __webpack_public_path__ + "static/media/gift-card-branded.035aebc5.svg";